import styled from 'styled-components';

export const Anchor = styled.a`
  display: inline-block;
  max-width: 20rem;

  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: top;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primaryExtended.opacityBackgroundText};

  &:hover {
    text-decoration: underline;
  }
`;
